import Dashboard from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
import BubbleChart from "@material-ui/icons/BubbleChart";
import LocationOn from "@material-ui/icons/LocationOn";
import Notifications from "@material-ui/icons/Notifications";
import Unarchive from "@material-ui/icons/Unarchive";
import Language from "@material-ui/icons/Language";
// core components/views for Admin layout
import DashboardPage from "views/Dashboard/DashboardF.js";
import UserProfile from "views/UserProfile/UserProfile.js";
import TableList from "views/TableList/TableList.js";
import Typography from "views/Typography/Typography.js";
import Icons from "views/Icons/Icons.js";
import Maps from "views/Maps/Maps.js";
import NotificationsPage from "views/Notifications/Notifications.js";
import UpgradeToPro from "views/UpgradeToPro/UpgradeToPro.js";
// core components/views for RTL layout
import RTLPage from "views/RTLPage/RTLPage.js";

const dashboardRoutesF = [
  
  {
    path: "/dashboard",
    name: "Bảng Thông Tin",
    rtlName: "لوحة القيادة",
    icon: Dashboard,
    component: DashboardPage,
    layout: "/farmer",
  },
  {
    path: "/user",
    name: "Thông Tin Cá Nhân",
    rtlName: "ملف تعريفي للمستخدم",
    icon: Person,
    component: UserProfile,
    layout: "/farmer",
  },
  {
    path: "/table",
    name: "Bảng Danh sách",
    rtlName: "قائمة الجدول",
    icon: "content_paste",
    component: TableList,
    layout: "/farmer",
  },
  {
    path: "/typography",
    name: "Quy Trình Chung",
    rtlName: "طباعة",
    icon: LibraryBooks,
    component: Typography,
    layout: "/farmer",
  },
  
  {
    path: "/maps",
    name: "Bản Đồ",
    rtlName: "خرائط",
    icon: LocationOn,
    component: Maps,
    layout: "/farmer",
  },
  {
    path: "/notifications",
    name: "Thông Báo",
    rtlName: "إخطارات",
    icon: Notifications,
    component: NotificationsPage,
    layout: "/farmer",
  },
];

export default dashboardRoutesF;
